<template>
  <ul>
    <li v-for="item in splitContent(data.content)">
      <template v-if="item.segments">
        <FormattedContent :data="segment" v-for="segment in item.segments">
          {{ $t(segment.content) }}
        </FormattedContent>
      </template>
      <template v-else>
        <FormattedContent :data="data">
          {{ $t(item) }}
        </FormattedContent>
      </template>
      <br>
    </li>
  </ul>
</template>
<script>
import dynamicLocalization from '../../../mixins/dynamic-localization';
import FormattedContent from './FormattedContent.vue';

export default {
  components: { FormattedContent },
  mixins: [dynamicLocalization],
  props: ["data"],
  methods: {
    splitContent(content) {
      return Array.isArray(content) ? content : [content]
    },
  }
}
</script>
